<template>
  <v-dialog
    v-model="isShow"
    :showClose="showClose"
    :width="width+'px'"
    @closed="handleCancel">
    <div class="dialog-container">
      <div class="dialog-header">
        <span>{{title}}</span>
      </div>
      <div class="dialog-body">
        <slot></slot>
      </div>
      <template >
        <div
          class="dialog-footer">
          <v-button
            gray
            @click="handleCancel">{{cancelText}}</v-button>
          <v-button
            green
            @click="handleNext">
            {{nextText}}
          </v-button>
        </div>
      </template>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'dialogNewComponent',
  props:{
    width:{
      type:[Number,String],
      default:400
    },
    value:{
      type:Boolean,
      default:false
    },
    showClose:{
      type:Boolean,
      default:false
    },
    title:{
      type:String,
      default:''
    },
    cancelText:{
      type:String,
      default:'Cancel'
    },
    nextText:{
      type:String,
      default:'Confirm'
    }
  },
  data(){
    return{
      isShow:false
    }
  },
  computed:{
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        this.isShow = val
      }
    }
  },
  methods:{
    handleCancel(){
      this.$emit('cancel')
      this.$emit('input',false)
    },
    handleNext(){
      this.$emit('next')
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
  font-family: 'inter';
}
.dialog-container {
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      /*margin: 10px 0px;*/
    }
  }
  .dialog-body{
    padding: 20px 15px;
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
  }
}
</style>
